import { useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { NSBanner, NSBoxBoolean, NSButtonRed, NSColumn, NSRow, NSSection, NSSpace, NSSpaceSizeType, StringFormatter } from 'namirasoft-site-react';
import { NSARouterMakerResult } from "namirasoft-account-react";
import { PaymentProps } from "../PaymentProps";
import { PaymentLayout } from "../PaymentLayout";
import { PaymentRoutes } from '../PaymentRoutes';

export interface SubscriptionCancellationConfirmationPageProps extends NSARouterMakerResult, PaymentProps
{ }

export interface SubscriptionCancellationConfirmationPageState
{
	isChecked: boolean;
}

function SubscriptionCancellationConfirmationPage(props: SubscriptionCancellationConfirmationPageProps)
{
	let NSBoxBoolean_Finalize = useRef<NSBoxBoolean>(null);

	let [state, setState] = useState<SubscriptionCancellationConfirmationPageState>({
		isChecked: false
	});

	let { id, cancellation_reason_id } = useParams();
	let cancellation_explaination = props.url.getQuery("cancellation_explaination");

	return (
		<PaymentLayout {...props}
			action={{
				title: "Final Warning",
				description: "Review important information about the consequences of canceling your subscription.",
				menus: {}
			}}
		>
			<NSSection>
				<NSColumn>
					<NSRow>
						<NSBanner
							imageLeft={{
								src: "https://static.namirasoft.com/image/concept/bot/warning.png",
								alt: "warning bot"
							}}
							imageRight={null}
							title={{
								text: "Are you sure?",
								style: {
									color: "rgba(255, 63, 63, 1)",
									fontWeight: "bold"
								}
							}}
						/>
					</NSRow>
				</NSColumn>
				<NSSpace size={NSSpaceSizeType.SMALL} />
				<NSColumn>
					<NSRow>
						<p style={{ fontWeight: "600" }}>
							{
								StringFormatter.toHTML("Canceling your subscription means you will lose access to the service/product at the end of your current billing period.<br>Please note that cancellations do not result in a refund for any remaining time,<br>but you will continue to have access until your subscription period ends.")
							}
						</p>
					</NSRow>
					<NSRow>
						<NSBoxBoolean
							ref={NSBoxBoolean_Finalize}
							required
							hideHeader
							defaultValue={state.isChecked}
							title='I understand that canceling my subscription will not provide a refund, and I will retain access until the end of my billing period.'
							style={{ width: "max-content" }}
							onChanged={(box) => setState(prevState => ({ ...prevState, isChecked: box.getValueBool() }))}
						/>
					</NSRow>
				</NSColumn>
				<NSSpace size={NSSpaceSizeType.NORMAL} />
				{
					state.isChecked &&
					<NSButtonRed
						title='Continue with the Cancellation'
						onClick={{
							action: async (onFinished: () => void) =>
							{
								try
								{
									if (id && cancellation_reason_id)
									{
										await props.servers.payment.subscription.Cancel(id, {
											cancellation_reason_id,
											cancellation_explaination
										});
										props.url.redirect(PaymentRoutes.SubscriptionCancellationResult(id, true, ""), {});
									}
								}
								catch
								{
									// The server already reported the error through the notifier.
								}
								finally
								{
									onFinished();
								}
							},
							showLoading: true
						}}
					/>
				}
			</NSSection>
		</ PaymentLayout >

	);
}

export default SubscriptionCancellationConfirmationPage;